export default async function postToken() {
  // eslint-disable-next-line consistent-return
  return new Promise((resolve) => {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

    if (isAndroid) {
      if (window.android && window.android.postToken) {
        console.log('获取token');
        resolve(window.android.postToken());
        return window.android.postToken();
      }
      resolve('');
    } else if (isiOS) {
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.postToken) {
        window.webkit.messageHandlers.postToken.postMessage('test');
        window.postToken = (v) => {
          resolve(v);
        };
      } else {
        resolve('');
      }
    } else {
      if (window.native && window.native.postToken) {
        console.log('获取token');
        resolve(window.native.postToken('{}'));
        return window.native.postToken('{}');
      }
      resolve('');
    }
  });
}
